export const specialDatesLeft = [
    { href: "https://www.meucupom.com/cupom-desconto-volta-as-aulas", label: "Volta às aulas" },
    { href: "https://www.meucupom.com/cupom-desconto-carnaval", label: "Carnaval" },
    { href: "https://www.meucupom.com/cupom-desconto-dia-do-consumidor", label: "Dia do consumidor" },
    { href: "https://www.meucupom.com/cupom-desconto-pascoa", label: "Páscoa" },
    { href: "https://www.meucupom.com/cupom-desconto-dia-das-maes", label: "Dia das mães" },
    { href: "https://www.meucupom.com/cupom-desconto-dia-do-orgulho-nerd", label: "Dia do orgulho nerd" },
    { href: "https://www.meucupom.com/cupom-desconto-dia-dos-namorados", label: "Dia dos namorados" },
    { href: "https://www.meucupom.com/cupom-desconto-copa-do-mundo-2018", label: "Copa do Mundo" },
    { href: "https://www.meucupom.com/cupom-desconto-ferias-de-julho", label: "Férias de julho" },
    { href: "https://www.meucupom.com/cupom-desconto-dia-dos-pais", label: "Dia dos pais" }
]